export default __webpack_public_path__ + "static/media/AspenSquare_LOGOColor.027446a4.png";